module.exports = __webpack_public_path__ + "images/pages/lp/down_arrow_1_9ec880c139e4082a7fc41b9f9b88cd60.png";